import { c as _c } from "react/compiler-runtime";
import { classNames, FlexCenter, TextBody, Truncate } from "@opensea/ui-kit";
export function ExpandedSearchLinkResult(t0) {
  const $ = _c(10);
  const {
    item,
    className
  } = t0;
  const Icon = item.data.icon;
  let t1;
  if ($[0] !== className) {
    t1 = classNames("h-9 w-full", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== Icon) {
    t2 = <Icon className="mr-2 scale-90" />;
    $[2] = Icon;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== item.data.title) {
    t3 = <Truncate><TextBody size="md">{item.data.title}</TextBody></Truncate>;
    $[4] = item.data.title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <FlexCenter className={t1}>{t2}{t3}</FlexCenter>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}